import "block/general";
import "block/text";
import Registration from "base/Registration";

(function () {
	"use strict";
	document.addEventListener("DOMContentLoaded", function () {
		Registration.blocksInit();
	});
})();
